import React from 'react';
import { Icon } from 'antd';
import { useSelector } from 'react-redux';
const SelectedFilters = ({ resetFilters }) => {
  const countActiveFilter = useSelector(
    state => state.Executorship.Offers.filters.count
  );
  return (
    <div className="filtersInfoPanel">
      {!countActiveFilter ? (
        <div>Выбрано фильтров: 0</div>
      ) : (
        <div className="btnGroup">
          <span className="filtersInfoBadge">
            <Icon
              style={{ fill: '#00a8ff' }}
              type="info-circle"
              theme="filled"
            />
            Выбрано фильтров:{' '}
            {countActiveFilter !== null ? countActiveFilter : 0}
          </span>
          <span className="resetFilters" onClick={resetFilters}>
            Сбросить
          </span>
        </div>
      )}
    </div>
  );
};

export default SelectedFilters;
